import React from "react";
import { Button, Tooltip } from "antd";
import { BulkActionConfig } from "../../interfaces/documentSet";

interface BulkActionButtonProps {
  config: BulkActionConfig;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
  loading?: boolean;
  loadingLabel?: string;
}

const BulkActionButton: React.FC<BulkActionButtonProps> = ({
  config,
  onClick,
  icon,
  label,
  loading = false,
  loadingLabel,
}) => {
  const { action, enabled, tooltip } = config;
  const isDisabled = !enabled || loading;

  return (
    <Tooltip title={tooltip}>
      <Button
        type="link"
        className={`bulk-action-alert__link ${action}-action`}
        onClick={onClick}
        disabled={isDisabled}
        loading={loading}
        icon={!loading && icon}
      >
        {loading && loadingLabel ? loadingLabel : label}
      </Button>
    </Tooltip>
  );
};

export default BulkActionButton;
